//TODO REMOVE APPSTATE-HOOKS ADD REDUX

import createAppState from './createAppState';

const initialState = {
  name: 'Unknown'
};

const mutators = {
  setName: (state, name) => {
    state.name = name;
  }
};

export const [AppStateProvider, useAppState] = createAppState(
  initialState,
  mutators
);
export default useAppState;
